import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import { get, map } from 'lodash/fp'

const GET_BASE_LETTER_SKUS = graphql`
  query GetBaseLetterSkus {
    allStripeSku(
      filter: {
        product: { name: { eq: "Letter" } }
        attributes: {
          maxQuantity: { eq: "500" }
          mailType: { eq: "First Class" }
        }
      }
    ) {
      edges {
        node {
          id
          active
          price
          attributes {
            size
            mailType
            minQuantity
            maxQuantity
            name
          }
          product {
            id
            name
          }
        }
      }
    }
  }
`

const DataBaseLetters = ({ Component }) => (
  <StaticQuery
    query={GET_BASE_LETTER_SKUS}
    render={({ allStripeSku }) => {
      const data = map(get('node'), allStripeSku.edges)
      return <Component data={data} product={'letters'} />
    }}
  />
)

export default DataBaseLetters
